module.exports = __webpack_public_path__ + "img/configure-parameters.0604765e.png";